import { generateImageUrl } from 'Utils/generateImageUrl'

interface Props {
	isFixed: boolean

	// Custom
	title?: string

	// Product
	nameTh?: string
	nameEn?: string
	featurePicturePath?: string
	shortDescription?: string
}

const TitleCell: React.FC<Props> = ({
	isFixed,
	title,
	nameEn,
	nameTh,
	featurePicturePath,
	shortDescription,
}) => {
	if (isFixed)
		return (
			<div className="d-flex flex-row align-items-center" style={{ columnGap: '12px' }}>
				{/* begin: Product Information */}

				<div className="d-none d-xl-inline-block">
					<img
						className="ms-0"
						src={
							featurePicturePath
								? generateImageUrl(featurePicturePath)
								: '/media/icons/kumopack/default-placeholder.png'
						}
						onError={(e: any) => {
							e.target.onerror = null
							e.target.src = '/media/icons/kumopack/default-placeholder.png'
						}}
						alt={nameEn}
						height={78}
					/>
				</div>

				<div className="d-inline-flex flex-column" style={{ rowGap: '5px' }}>
					<div className="fw-bold text-kumopack-grey-900 fs-4">
						{nameTh} - {nameEn}
					</div>
					<div className="text-kumopack-grey-600">
						{String(shortDescription).length > 0 ? shortDescription : '-'}
					</div>
				</div>

				{/* end: Product Information */}
			</div>
		)
	else {
		return <div dangerouslySetInnerHTML={{ __html: title ?? '-' }}></div>
	}
}

export default TitleCell
